/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ImportPublicHolidaysRequest,
  ImportPublicHolidaysResponse,
  ProblemDetails,
  PublicHolidayResponse,
} from '../models/index';
import {
    ImportPublicHolidaysRequestFromJSON,
    ImportPublicHolidaysRequestToJSON,
    ImportPublicHolidaysResponseFromJSON,
    ImportPublicHolidaysResponseToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    PublicHolidayResponseFromJSON,
    PublicHolidayResponseToJSON,
} from '../models/index';

export interface ImportPublicHolidaysOperationRequest {
    importPublicHolidaysRequest: ImportPublicHolidaysRequest;
}

/**
 * PublicHolidaysApi - interface
 * 
 * @export
 * @interface PublicHolidaysApiInterface
 */
export interface PublicHolidaysApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicHolidaysApiInterface
     */
    getPublicHolidaysRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PublicHolidayResponse>>>;

    /**
     */
    getPublicHolidays(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PublicHolidayResponse>>;

    /**
     * 
     * @param {ImportPublicHolidaysRequest} importPublicHolidaysRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicHolidaysApiInterface
     */
    importPublicHolidaysRaw(requestParameters: ImportPublicHolidaysOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ImportPublicHolidaysResponse>>;

    /**
     */
    importPublicHolidays(requestParameters: ImportPublicHolidaysOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ImportPublicHolidaysResponse>;

}

/**
 * 
 */
export class PublicHolidaysApi extends runtime.BaseAPI implements PublicHolidaysApiInterface {

    /**
     */
    async getPublicHolidaysRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PublicHolidayResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/settings/public-holidays`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PublicHolidayResponseFromJSON));
    }

    /**
     */
    async getPublicHolidays(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PublicHolidayResponse>> {
        const response = await this.getPublicHolidaysRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async importPublicHolidaysRaw(requestParameters: ImportPublicHolidaysOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ImportPublicHolidaysResponse>> {
        if (requestParameters['importPublicHolidaysRequest'] == null) {
            throw new runtime.RequiredError(
                'importPublicHolidaysRequest',
                'Required parameter "importPublicHolidaysRequest" was null or undefined when calling importPublicHolidays().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/settings/public-holidays/import`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ImportPublicHolidaysRequestToJSON(requestParameters['importPublicHolidaysRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ImportPublicHolidaysResponseFromJSON(jsonValue));
    }

    /**
     */
    async importPublicHolidays(requestParameters: ImportPublicHolidaysOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ImportPublicHolidaysResponse> {
        const response = await this.importPublicHolidaysRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
